import { render, staticRenderFns } from "./LanguageControl.vue?vue&type=template&id=4d8e3446&scoped=true"
import script from "./LanguageControl.vue?vue&type=script&lang=js"
export * from "./LanguageControl.vue?vue&type=script&lang=js"
import style0 from "./LanguageControl.vue?vue&type=style&index=0&id=4d8e3446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e3446",
  null
  
)

export default component.exports